<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <!-- <v-card-title>Change Learner Division</v-card-title> -->
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Change Learner Division</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row justify="center">
          <v-col sm="2">
            <v-combobox dense required v-model="academicyear" :items="ay_list" item-text="ay" item-value="id"
              label="Academic Year" outlined persistent-hint hint="* Select Academic Year"
              @change="getStudentAndDivisionDetails()" />
          </v-col>
          <v-col cols="5">
            <v-autocomplete :items="learner_list" item-text="learner" item-value="id" dense outlined
              label="Student List" @change="getDivisionDetails(selected_student)"
              v-model="selected_student"></v-autocomplete>
          </v-col>
          <v-col cols="5" v-if="division_list.length > 0">
            <v-autocomplete :items="division_list" item-text="division" item-value="id" dense outlined
              label="Division List" v-model="selected_division"></v-autocomplete>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="5"> </v-col>
          <v-col cols="6">
            <v-btn @click="save()" color="info" :loading="loader">Save</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="box" v-if="division_details.length > 0">
      <!-- <v-card-title>Current Division Details</v-card-title> -->
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Current Division Details</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <template>
          <v-data-table :items="division_details" :headers="headers" class="elevation-1" :search="search">
          </v-data-table>
        </template>
      </v-card-text>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },

  data: () => ({
    overlay: false,
    search: "",
    snackbar_msg: "",
    snackbar: false,
    // extraBreadcrumbItems: [
   

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    color: "",
    learner_list: [],
    division_list: [],
    selected_student: "",
    loader: false,
    division_details: [],
    selected_division: "",
    headers: [
      { text: "rollno", value: "rollno", sortable: true },
      { text: "Standard", value: "standard", sortable: true },
      { text: "Division", value: "division", sortable: true },
      { text: "Academic Year", value: "academicyear", sortable: true },
    ],
    academicyear: "",
    ay_list: [],
  }),
  methods: {
    save() {
      this.overlay = true;
      this.loader = true;
      if (this.selected_division == "" || this.selected_division == null) {
        this.overlay = false;
        this.showSnackbar("#b71c1c", "Please Select Division..");
        this.loader = false;
        return;
      }
      const formData = {
        ay_id: this.academicyear.id,
        learner: this.selected_student,
        division: this.selected_division,
      };
      axios
        .post("Admission/saveChangeDivOffering", formData)
        .then((res) => {
          this.overlay = false;
          if (res.data.status == "SUCCESS") {
            (this.division_details = res.data.division_details),
              (this.loader = false);
            this.showSnackbar("#4CAF50", "Division Changed Successfully..");
            //  this.onload();
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
            this.loader = false;
          }
        })
        .catch((error) => {
          this.overlay = false;
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getDivisionDetails(item) {
      this.overlay = true;
      const formData = {
        ay_id: this.academicyear.id,
        learner: item,
      };
      axios
        .post("Admission/getDivisionDetails", formData)
        .then((res) => {
          this.overlay = false;
          if (res.data.status == "SUCCESS") {
            (this.division_details = res.data.division_details),
              (this.division_list = res.data.division_list);
          } else {
            this.showSnackbar("#b71c1c", "No data found!");
          }
        })
        .catch((error) => {
          this.overlay = false;
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getStudentAndDivisionDetails() {
      this.overlay = true;
      const formData = {
        ay_id: this.academicyear.id,
      };
      axios
        .post("Admission/getStudentAndDivisionDetails", formData)
        .then((res) => {
          this.overlay = false;
          if (res.data.status == "SUCCESS") {
            this.learner_list = res.data.learner_list;
            this.division_list = [];
          } else {
            this.showSnackbar("#b71c1c", "No data found!");
          }
        })
        .catch((error) => {
          this.overlay = false;
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      this.overlay = true;
      axios
        .post("Admission/changeLearnerDivision")
        .then((res) => {
          this.overlay = false;
          if (res.data.status == "SUCCESS") {
            this.learner_list = res.data.learner_list;
            this.academicyear = res.data.current_ay;
            this.ay_list = res.data.ay_list;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.overlay = false;
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
  mounted() {
    this.onload();
  },
  watch: {},
};
</script>
<style scoped>
@media (min-width: 320px) and (max-width: 767.98px) {
}
@media (min-width: 768px) and (max-width: 991.98px) {
}
@media (min-width: 992px) and (max-width: 1024px) {
}
</style>
